import { render, staticRenderFns } from "./Personal-Information.vue?vue&type=template&id=6422248a&scoped=true&"
import script from "./Personal-Information.vue?vue&type=script&lang=js&"
export * from "./Personal-Information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6422248a",
  null
  
)

export default component.exports